export default __webpack_public_path__ + "static/media/a5.fc3a4633.png";